// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19DLf","image":"Header_image__Xmjlr","name":"Header_name__10DA7","info":"Header_info__954LD","infoRow":"Header_infoRow__H4Gxd"};